/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Review5_SubInputs */

const es_landing_review5_sub = /** @type {(inputs: Landing_Review5_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruta nocturna`)
};

const gl_landing_review5_sub = /** @type {(inputs: Landing_Review5_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruta nocturna`)
};

const en_landing_review5_sub = /** @type {(inputs: Landing_Review5_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Night route`)
};

/**
* | output |
* | --- |
* | "Night route" |
*
* @param {Landing_Review5_SubInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_review5_sub = /** @type {((inputs?: Landing_Review5_SubInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Review5_SubInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_review5_sub(inputs)
	if (locale === "en") return en_landing_review5_sub(inputs)
	return es_landing_review5_sub(inputs)
});